document.addEventListener("DOMContentLoaded", function () {
    //    折叠按钮的显示与隐藏
    window.toggleIcons = function() {
        document.querySelectorAll(".popular-search-con-out").forEach(popularSearchOut => {
            const popularSearch = popularSearchOut.querySelector(".popular-search-out");
            const historyList = popularSearchOut.querySelector(".historyList");
            const downIcon = popularSearchOut.parentElement.querySelector(".icon-down");
    
            if (!downIcon) {
                console.warn("找不到 .icon-down，检查 HTML 结构", popularSearchOut);
                return; // ❌ 避免 null 访问 style
            }
    
            if (historyList) {
                console.log('对应高度', historyList.scrollHeight, popularSearch.offsetHeight);
                if (historyList.scrollHeight - popularSearch.offsetHeight > 2) {
                    downIcon.style.display = "inline-block"; // 显示
                } else {
                    downIcon.style.display = "none"; // 隐藏
                }
            }
        });
    };
    window.toggleIcons(); // 初始化检查
    window.addEventListener("resize", window.toggleIcons); // 确保调用的是全局 `toggleIcons`




    const searchInput = document.querySelector(".Search__Input"); // 搜索输入框
    const searchButton = document.querySelector("#SearchButton"); // 搜索按钮
    const searchSuggestions = document.getElementById("SearchSuggestions");
    const clearButton = document.querySelector(".clear-button");

    let textDisplay = document.querySelector(".input-text");

    searchInput.addEventListener("blur", function () {
        if (searchInput.value.length > 0) {
            textDisplay.textContent = searchInput.value;
            textDisplay.style.display = "block";
            searchInput.style.display = "none";
        }
    });
    // 监听输入事件
    $('.Search__Input').on('input', function() {
        console.log('输入的值变化',searchInput.value);
        // 输入框的值发生变化时，实时更新 .input-text
        $('.Search__Input').attr('value',searchInput.value);
    });
    textDisplay.addEventListener("click", function () {
        searchInput.style.display = "block";
        textDisplay.style.display = "none";
        searchInput.focus();
        searchSuggestions.style.display = "block";
        // 控制结果弹窗内容
        const suggestionBox = document.querySelector('.Search__Suggestions');
        let scrollTimeout = null;

        suggestionBox.addEventListener('scroll', () => {
        suggestionBox.classList.add('scrolling');

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            suggestionBox.classList.remove('scrolling');
        }, 1000); // 停止滚动后 500ms 隐藏滚动条
        });

    });
    
    function fetchSearchSuggestions(query) {
        if (query.length < 2) {
            searchSuggestions.style.display = "none";
            return;
        }
        const shopifyAPI = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query`;
        // const shopifyAPI = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article,page&resources[limit]=5`;
    
        fetch(shopifyAPI)
            .then(res => res.ok ? res.json() : Promise.reject("Shopify API 失败"))
            .then(data => {
                if (!data.resources) {
                    throw new Error("API 返回数据结构不对");
                }
                let suggestionsHTML = "<ul>";
                const querySuggestions = data.resources.results.queries || []; // 🔹 获取联想搜索关键词
                const resultList = data.resources.results;
    
                console.log('搜索出来的结果内容', resultList, querySuggestions);
    
                // 🔹 处理联想搜索关键词（加绿色标识）
                if (querySuggestions.length > 0) {
                    querySuggestions.forEach(q => {
                        suggestionsHTML += `
                            <li class="search-query" onclick="saveSearchRecordAndRedirect('${q.text}', '${q.url}')">
                                <span class="highlight">${highlightKeyword(q.text, query)}</span>
                            </li>
                        `;
                    });                    
                }

    
                // 🔹 分类（Collections）
                const collections = data.resources.results.collections || [];
                if (collections.length > 0) {
                    collections.forEach(collection => {
                        suggestionsHTML += `
                        <li onclick="saveSearchRecordAndRedirect('${collection.title}', '${collection.url}')">
                            <span>${highlightKeyword(collection.title, query)}</span>
                        </li>`;
                    });
                }
                

                suggestionsHTML += "</ul>";
                // 🔹 判断 `<li>` 是否存在
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = suggestionsHTML;
                const liCount = tempDiv.querySelectorAll("li").length;

                if (liCount > 0) {
                    searchSuggestions.innerHTML = suggestionsHTML;
                    searchSuggestions.style.display = "block";
                } else {
                    searchSuggestions.innerHTML = "";
                    searchSuggestions.style.display = "none";
                }
   
            })
            .catch(error => {
                console.error("Error fetching search suggestions:", error);
                searchSuggestions.innerHTML = "<p>搜索建议加载失败</p>";
                searchSuggestions.style.display = "block";
            });
    }
    
    // 🔹 关键词高亮函数
    function highlightKeyword(text, query) {
        if (!query) return text; // 如果搜索词为空，直接返回原文本
    
        const regex = new RegExp(`(${query})`, "gi"); // 🔹 直接用搜索框输入的关键词
        return text.replace(regex, `<span class="search-highlight">$1</span>`);
    }


    // 监听输入框
    searchInput.addEventListener("input", function () {
        fetchSearchSuggestions(searchInput.value.trim());
        if (searchInput.value.length > 0) {
            clearButton.style.display = "block"; // 显示删除按钮
        } else {
            clearButton.style.display = "none"; // 隐藏删除按钮
        }
          // 点击删除按钮
        clearButton.addEventListener("click", function () {
            searchInput.value = ""; // 清空输入框
            textDisplay.textContent = ''; 
            searchInput.style.display = "block";
            textDisplay.style.display = "none";
            clearButton.style.display = "none"; // 隐藏删除按钮
            searchInput.focus(); // 重新聚焦输入框
            searchSuggestions.style.display = 'none';  // 隐藏搜索建议

        });
    });

    // 监听搜索按钮
    searchButton.addEventListener("click", function () {
        // fetchSearchSuggestions(searchInput.value.trim());
        searchSuggestions.style.display = "none";
    
    });

    // 监听输入框聚焦，只有在有内容时才显示搜索建议
    searchInput.addEventListener("focus", function () {
        if (searchInput.value.trim() !== "") {  // 只有输入框有内容时才显示
            searchSuggestions.style.display = "block";
            console.log('搜索框聚焦，显示搜索建议');
        } else {
            console.log('搜索框聚焦，但内容为空，不显示搜索建议');
        }
    });

    // 点击页面其他地方时，隐藏搜索建议
    document.addEventListener("click", function (event) {
        // 如果点击的不是输入框和搜索建议框，则隐藏搜索建议
        if (!textDisplay.contains(event.target) && !searchSuggestions.contains(event.target)) {
            console.log('点击的是哪个位置', event.target);
            searchSuggestions.style.display = "none";
        }
    });
    // 监听 #SearchSuggestions 的鼠标移出事件
    // searchSuggestions.addEventListener('mouseleave', function() {
    //     searchSuggestions.style.display = 'none';  // 隐藏搜索建议
    // });
    // 输入时触发搜索建议
    // searchInput.addEventListener("input", function () {
    //   fetchSearchSuggestions(searchInput.value.trim());
    // });
  
    // // 点击搜索按钮时触发搜索建议
    // searchButton.addEventListener("click", function () {
    //   fetchSearchSuggestions(searchInput.value.trim());
    // });
  
    // // 点击页面其他地方，隐藏搜索建议
    // document.addEventListener("click", function (event) {
    //   if (!searchInput.contains(event.target) && !searchSuggestions.contains(event.target) && event.target !== searchButton) {
    //     searchSuggestions.style.display = "none";
    //   }
    // });

    
    const searchResultsElement = document.querySelector(".Search__Results"); // 结果容器

    if (!searchInput || !searchButton || !searchResultsElement) {
        return;
    }

    // 阻止回车提交搜索
    searchInput.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    });
    searchButton.addEventListener("click", function () {
        var query = searchInput.value.trim();
    
        // 如果输入为空，就用 placeholder 作为搜索词
        if (!query) {
            query = searchInput.getAttribute("placeholder") || "";
        }
    
        if (!query) return; // 依然防止 placeholder 也为空的情况
    
        var queryOptions = {
            method: 'GET',
            credentials: 'same-origin'
        };
    
        var queries = [
            fetch(`${window.routes.searchUrl}?section_id=predictive-search&q=${encodeURIComponent(query)}*&type=product`, queryOptions)
        ];
    
        if (window.theme.searchMode !== 'product') {
            queries.push(
                fetch(`${window.routes.searchUrl}?section_id=predictive-search&q=${encodeURIComponent(query)}*&type=${window.theme.searchMode.replace('product,', '')}`, queryOptions)
            );
        }
    
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
        Promise.all(queries).then(function (responses) {
            Promise.all(responses.map(response => response.text())).then(function (contents) {
                let finalUrl = '';
                if (window.theme.searchMode === 'product') {
                    console.log('搜索n个商品', encodeURIComponent(query));
                    searchResultsElement.innerHTML = contents[0];
                } else {
                    console.log('搜索不到商品', contents[0], encodeURIComponent(query));
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(contents[0], 'text/html');
    
                    const viewAllLink = doc.querySelector('#shopify-section-predictive-search .Segment__Title a');
    
                    if (viewAllLink && viewAllLink.getAttribute('href')) {
                        console.log('跳转到:', viewAllLink.getAttribute('href'));
                        window.location.href = viewAllLink.getAttribute('href');
                        finalUrl = viewAllLink.getAttribute('href');
                    } else {
                        console.log("href 为空、undefined 或 null，跳转到搜索结果页");
                        window.location.href = `/pages/search-results-page?q=${encodeURIComponent(query)}`;
                        finalUrl = `/pages/search-results-page?q=${encodeURIComponent(query)}`;
                    }
                }
                // ✅ 搜索结果处理完后再保存历史
                if (finalUrl) {
                    saveInput(query, finalUrl);
                }
                searchResultsElement.setAttribute('aria-hidden', 'false');
            });
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
    });
    
    // searchButton.addEventListener("click", function () {
    //     var query = searchInput.value.trim();
    //     if (!query) return;

    //     var queryOptions = {
    //         method: 'GET',
    //         credentials: 'same-origin'
    //     };

    //     var queries = [
    //         fetch(`${window.routes.searchUrl}?section_id=predictive-search&q=${encodeURIComponent(query)}*&type=product`, queryOptions)
    //     ];

    //     if (window.theme.searchMode !== 'product') {
    //         queries.push(
    //             fetch(`${window.routes.searchUrl}?section_id=predictive-search&q=${encodeURIComponent(query)}*&type=${window.theme.searchMode.replace('product,', '')}`, queryOptions)
    //         );
    //     }

    //     document.dispatchEvent(new CustomEvent('theme:loading:start'));

    //     Promise.all(queries).then(function (responses) {
    //         Promise.all(responses.map(response => response.text())).then(function (contents) {
    //             if (window.theme.searchMode === 'product') {
    //                 console.log('搜索n个商品',encodeURIComponent(query));
    //                 searchResultsElement.innerHTML = contents[0];
    //             } else {
    //                 console.log('搜索不到商品',contents[0],encodeURIComponent(query));
    //                             // 解析 HTML，提取链接
    //                 const parser = new DOMParser();
    //                 const doc = parser.parseFromString(contents[0], 'text/html');

    //                 const viewAllLink = doc.querySelector('#shopify-section-predictive-search .Segment__Title a');

    //                 if (viewAllLink && viewAllLink.getAttribute('href')) {
    //                     console.log('跳转到:', viewAllLink.getAttribute('href'));
    //                     window.location.href = viewAllLink.getAttribute('href');
    //                 } else {
    //                     console.log("href 为空、undefined 或 null，跳转到搜索结果页");
    //                     window.location.href = `/pages/search-results-page?q=${encodeURIComponent(query)}`;
    //                 }
    //                 // searchResultsElement.innerHTML = `
    //                 //     <div class="PageLayout PageLayout--breakLap">
    //                 //         <div class="PageLayout__Section">${contents[0]}</div>
    //                 //         <div class="PageLayout__Section PageLayout__Section--secondary">${contents[1]}</div>
    //                 //     </div>`;
    //                 //     console.log('点击获取view all的内容',$('#shopify-section-predictive-search .Segment__Title span').text(),$('#shopify-section-predictive-search .Segment__Title a').attr('href'));
                    
    //                 //     if (!$('#shopify-section-predictive-search .Segment__Title a').attr('href')) {
    //                 //         console.log("href 为空、undefined 或 null");
    //                 //         window.location.href = `/pages/search-results-page?q=${encodeURIComponent(query)}`;
    //                 //     }else{
    //                 //         window.location.href = $('#shopify-section-predictive-search .Segment__Title a').attr('href');
    //                 //     }
    //             }
    //             searchResultsElement.setAttribute('aria-hidden', 'false');
    //         });
    //         document.dispatchEvent(new CustomEvent('theme:loading:end'));
           
            
    //     });
    // });
});

function setSearchHeight() {
    const searchEl = document.getElementById('Search');
    if (!searchEl) return;
  
    const safeAreaBottom = parseInt(getComputedStyle(document.documentElement)
      .getPropertyValue('--safe-area-bottom')) || 0;
  
    // 实际可见高度减去顶部固定 60px，再减去安全区
    searchEl.style.height = (window.innerHeight - safeAreaBottom) + 'px';
}
  
  // 首次执行
setSearchHeight();
  
  // 监听变化
window.addEventListener('resize', setSearchHeight);
window.addEventListener('orientationchange', setSearchHeight);
  
$(function(){
    $('.popular-search-con-out').each(function(){
        console.log('循环');
        $(this).find('span').click(function(){
            if($(this).hasClass('icon-down')) {
                console.log('点击展开',$(this));
                $(this).parent().find('.popular-search-out').css('max-height','none');
                $(this).parent().find('.popular-search-out').css('overflow-y','auto');
                $(this).addClass('icon-up').removeClass('icon-down');
            }else{
                console.log('点击折叠');
                if(jQuery(window).width()<=768){
                    $(this).parent().find('.popular-search-out').css('max-height','135px');
                }else{
                    $(this).parent().find('.popular-search-out').css('max-height','49px');
                }
                $(this).parent().find('.popular-search-out').css('overflow-y','hidden');
                $(this).addClass('icon-down').removeClass('icon-up');
            }
        })
    })

})
function saveSearchRecordAndRedirect(text, url) {
    saveInput(text, url);
    location.href = url;
}
// 滚动显示滚动条，不滚动隐藏滚动条
if(jQuery(window).width() > 769){
    const suggestionBox = document.querySelector('.Search__Suggestions');
    let scrollTimeout = null;
    
    suggestionBox.addEventListener('scroll', () => {
        console.log('开始滑动');
      suggestionBox.classList.add('scrolling');
    
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        suggestionBox.classList.remove('scrolling');
      }, 500); // 停止滚动后 500ms 隐藏滚动条
    });
}


$(document).ready(function() {
    console.log('进来');
      // 检查本地存储中是否有搜索历史记录
      var history = localStorage.getItem('searchHistory');
      if (history) {
          history = JSON.parse(history);
          displaySearchHistory(history);
      }
      var inputTimeout;
      var saveDelay = 5000; // 30秒
      var newArr=[];
      $('.Search__SearchBar-out').on('click', ' .search-button', function() {
        // var inputValue = $(this).val();
            const inputValue = $('.Search__SearchBar-out .Search__InputIconWrapper .Search__Input').val().trim();
            console.log('点击搜索，内容为：', inputValue);

            // 只有有内容时才保存
            // if (inputValue !== '') {
            //     saveInput(inputValue);
            // }
      })

    
      $('.search_list  h2 .iconfont').click(function(){
        console.log('点击清空按钮');
        $('.sure-popup').removeClass('none');
        $('.sure-popup .window-cover').show();
        $('.sure-popup .sure-popup-main .pop_title').hide();
        $('.sure_popup-btn-right').click(function(){
            $('.sure-popup').addClass('none');
            $('.sure-popup .window-cover').hide();
        })
        $('.sure_popup-btn-left').click(function(){
            localStorage.removeItem("searchHistory");
            $('.historyList').html('');
            $('.search_list').addClass('none');
            $('.sure-popup').addClass('none');
            $('.sure-popup .window-cover').hide();
        })
        // 点击灰色遮罩
        $('.sure-popup .window-cover').off('click').on('click', function(){
            $('.sure-popup').addClass('none');
            $(this).hide();
        });
      })
  });

  // 保存搜索历史
function saveInput(text, url = '') {
    if (text.trim() === "") return;

    let history = localStorage.getItem('searchHistory');
    history = history ? JSON.parse(history) : [];

    // 去重
    history = history.filter(item => item.text !== text);

    // 添加新记录到最前
    history.unshift({ text, url });

    // 限制最多 10 条
    history = history.slice(0, 10);

    localStorage.setItem('searchHistory', JSON.stringify(history));
    displaySearchHistory(history);
}
//   function saveInput(text, url = '') {
//     if (text.trim() === "") return;

//     let history = localStorage.getItem('searchHistory');
//     history = history ? JSON.parse(history) : [];

//     // 去重：移除已有的相同 text
//     history = history.filter(item => item.text !== text);

//     // 添加新记录到最前
//     history.unshift({ text, url });

//     // 限制最大条数（例如 10 条）
//     history = history.slice(0, 10);

//     localStorage.setItem('searchHistory', JSON.stringify(history));
//     displaySearchHistory(history);
// }


   // 显示搜索历史
function displaySearchHistory(history) {
    const historyList = $('.historyList');
    historyList.empty();

    history.forEach(function(item) {
        const a = $('<a></a>')
            .attr('href', item.url && item.url !== '' ? item.url : 'javascript:;')
            .text(item.text);

        historyList.append(a);
    });

    if ($('.historyList a').length > 0) {
        $('.search_list').removeClass('none');
    }

    $('.historyList a').each(function () {
        $(this).off("click").on("click", function(e) {
            const text = $(this).text();
            const href = $(this).attr('href');
            if (href === 'javascript:;') {
                e.preventDefault();
                $('.has-recommendation .search__input').val(text).trigger('input').focus();
            }
        });
    });
}
// function displaySearchHistory(history) {
//     const historyList = $('.historyList');
//     historyList.empty();

//     history.forEach(function(item) {
//         const a = $('<a></a>')
//             .attr('href', item.url && item.url !== '' ? item.url : 'javascript:;')
//             .text(item.text);

//         historyList.append(a);
//     });

//     if ($('.historyList a').length > 0) {
//         $('.search_list').removeClass('none');
//     }

//     $('.historyList a').each(function () {
//         $(this).off("click").on("click", function() {
//             const text = $(this).text();
//             const href = $(this).attr('href');
//             if (href === 'javascript:;') {
//                 $('.has-recommendation .search__input').val(text).trigger('input').focus();
//             }
//         });
//     });
// }
function adjustPaddingBottom() {
    const searchProduct = document.querySelector(".search_recommended_product");
    if (!searchProduct || !window.visualViewport) return;
  
    const viewportHeight = window.visualViewport.height;
    const windowHeight = window.innerHeight;
    const bottomPadding = windowHeight - viewportHeight;
  
    // 给额外缓冲 16px
    const finalPadding = bottomPadding > 0 ? bottomPadding + 30 : 30;
    searchProduct.style.paddingBottom = `${finalPadding}px`;
}
  
//   function adjustPaddingBottom() {
//     const searchProduct = document.querySelector(".search_recommended_product");
//     if (!searchProduct) return;
  
//     const viewportHeight = window.visualViewport.height; // 真机上的可视高度
//     const windowHeight = window.innerHeight; // 浏览器窗口高度
//     const bottomPadding = windowHeight - viewportHeight; // 计算底部被遮挡的高度
  
//     searchProduct.style.paddingBottom = `${bottomPadding + 2}rem`; // 额外加上 8rem
//   }
  
  // 初始化
  adjustPaddingBottom();
  
  // 监听屏幕变化（键盘弹起时自动调整）
  window.visualViewport.addEventListener("resize", adjustPaddingBottom);
  
